import { render, staticRenderFns } from "./DistributionProductsFormComponent.vue?vue&type=template&id=574c781e"
import script from "./DistributionProductsFormComponent.vue?vue&type=script&lang=js"
export * from "./DistributionProductsFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports